<template>
    <div class="story-maker-sticker story-maker-sticker-survey" :class="{edit: isEditing}">
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="finish">Terminé</p>
        <div class="sticker sticker-survey" 
            :style="{ 
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
            }"
        >
            <div class="survey-header" v-if="isEditing || models.question">
                <textarea cols="20" rows="2" wrap="hard" maxlength="100" placeholder="POSEZ UNE QUESTION..." v-model="models.question" :readonly="!isEditing"></textarea>
            </div>
            <div class="choises">
                <div class="choise" v-for="(_,index) in Array.from({ length:4})" v-if="(isEditing || models.responses[index]) && (index < 3 || (models.responses[2] || models.responses[3]))" :class="{optional: index >= 2 && !models.responses[index]}">
                    <textarea 
                        v-if="isEditing"
                        cols="20" 
                        rows="2" 
                        wrap="hard" 
                        maxlength="100" 
                        :placeholder="['Oui','Non' , 'Ajoutez une option', 'Ajoutez une option'][index]" 
                        v-model="models.responses[index]"
                        >
                    </textarea>

                    <textarea 
                        v-else
                        cols="20" 
                        rows="2" 
                        wrap="hard" 
                        maxlength="100" 
                        :placeholder="['Oui','Non' , 'Ajoutez une option', 'Ajoutez une option'][index]" 
                        v-model="models.responses[index]"
                        :readonly="true"
                        @mousedown.prevent
                        @selectstart.prevent
                        >
                    </textarea>
                </div>
            </div>
        </div>
     
    </div>
</template>

<script>


    export default {
        props: {
            id: Number | String,
            isEditing: Boolean,
            question: String,
            responses: Array,
            isPreventCover: Boolean,
            isCover: Boolean,
            setCover: Function,
            setCbClick: Function,
        },
        data() {
            return {
                timeoutFinish: null,
                models : {
                    question: "",
                    responses: []
                }
            }
        },

        mounted () {
            if (this.setCbClick) this.setCbClick(this.clickSticker);
        },

        methods: {
            clickSticker() {
                if (this.isEditing) return 
                this.setCover(true)
                this.$nextTick(()=> {
                    this.$emit('updateSticker',this.id , {
                        isEditing: true
                    })   
                })
            },

            finish() {
                this.$emit('updateSticker',this.id , {
                    isEditing: false,
                    data : {
                        question : this.models.question,
                        responses : this.models.responses.filter(res => res.length)
                    },
                })

                if (this.timeoutFinish) clearTimeout(this.timeoutFinish)
                this.timeoutFinish = setTimeout(() => {
                    this.setCover(false)
                }, 200);
            },
        },

        watch: {
            question: {
                handler(newValue) {
                    this.models.question = newValue
                },
                immediate: true
            },
            responses: {
                handler(newValue) {
                    this.models.responses = newValue
                },
                immediate: true
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
<!-- https://vuejs.org/guide/built-ins/transition-group -->